import React, { useEffect, useState } from "react";
import { Button, CloseButton, Modal } from "react-bootstrap";
import secureLocalStorage from "react-secure-storage";
import AgentPerformance from "./AgentPerformance";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TotalTalkTime from "./TotalTalkTime";
import { quotes } from "modules/utilities/utility_2";
import { useAgentCall } from "./store/store";
import { RiseOutlined, FallOutlined } from "@ant-design/icons";
import corner1 from "assets/img/illustrations/corner-2.png";
import Background from "modules/common/Background";
import useActionableListStore from "modules/dashboards/actionable_list/store";
import { getCurrentUserRole } from "modules/utilities/utility";

function AgentDetailModal() {
  const [modalShow, setModalShow] = useState(true);
  const [slideCount, setSlideCount] = useState(0);
  const agentName = secureLocalStorage.getItem("first_name");
  const { todayEngData, todayLoading, fetchTodayEngData, slotBookingData, fetchLeadSlotBooking } = useActionableListStore();
  const { agentFeedbackData, fetchAgentFeedback } = useAgentCall();
  const isLeadAgent = getCurrentUserRole() === "lead_agent";

  useEffect(() => {
    fetchAgentFeedback();
    if (isLeadAgent) {
      fetchLeadSlotBooking(1);
    } else {
      fetchTodayEngData();
    }
  }, []);

 const engData = isLeadAgent ? slotBookingData : todayEngData;
 const tagWiseData = engData?.reduce((prev, curr)=>{
    if(prev[curr.tag]){
      prev[curr.tag] += 1;
      }else{
        prev[curr.tag] = 1;
      }
      return prev;
  },{});

  const handleClose = () => {
    secureLocalStorage.setItem("popUp_Count", 1);
    setModalShow(false);
  };


  return (
    <div>
      {!secureLocalStorage.getItem("popUp_Count") && (
        <Modal
          show={modalShow}
          onHide={handleClose}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter" className="w-100">
              <div className="text-center">
                {slideCount
                  ? "Today Available Call"
                  : "Yesterday's Performance Review"}
              </div>
            </Modal.Title>
            <CloseButton
              className="btn btn-circle btn-sm transition-base p-0"
              onClick={handleClose}
            />
          </Modal.Header>
          <Modal.Body>
            {slideCount ? (
              <div>
                <div className="fs-2 border-bottom d-flex align-items-center border-bottom my-n2">
                  <span className="mx-2"> Hello </span>{" "}
                  <span> {agentName?.toUpperCase()}! </span>
                  <span className="wave fs-4 mt-n2">👋</span>{" "}
                  <marquee className="mx-4 text-animated" style={{ width: "80%" }}>
                    {quotes[Math.floor(Math.random() * quotes.length)]}
                  </marquee>
                </div>
                <div className="mt-3">
                  <TotalTalkTime tagWiseCall={tagWiseData} />
                </div>
              </div>
            ) : (
              <div>
                <div className="p-2 d-flex flex-column gap-1">
                  <div className="fs-2 border-bottom d-flex align-items-center my-n2">
                    <span className="mx-2"> Hello </span>{" "}
                    <span> {agentName?.toUpperCase()}! </span>
                    <span className="wave fs-4 mt-n2">👋</span>{" "}
                    <marquee
                      className="mx-4 text-animated"
                      style={{ width: "70%" }}
                    >
                      {quotes[Math.floor(Math.random() * quotes.length)]}
                    </marquee>
                  </div>
                </div>
                <div className="mt-2">
                  <AgentPerformance />
                </div>
                <div className="p-2 mt-2">
                  <div className="text-primary fs-2">Customer Satisfaction</div>
                  <div className="border-bottom font-poppins mb-1">
                    Here is What the customer says.
                  </div>
                  <div className="d-flex card p-2 flex-row gap-3 align-items-center w-25">
                    <Background
                      image={corner1}
                      style={{
                        borderTopRightRadius: "0.375rem",
                        borderBottomRightRadius: "0.375rem",
                      }}
                    />
                    <div className="d-flex flex-column gap-1 p-2">
                      <div className="d-flex flex-row align-items-center gap-3">
                        <Rating
                          initialRating={
                            agentFeedbackData?.yesterdayAverageRating
                          }
                          className="fs-5"
                          fullSymbol={
                            <FontAwesomeIcon
                              icon="star"
                              className="text-warning"
                            />
                          }
                          emptySymbol={
                            <FontAwesomeIcon icon="star" className="text-300" />
                          }
                          readonly
                        />
                        <div className="fs-1">
                          {agentFeedbackData?.yesterdayCustomerCount}
                        </div>
                      </div>
                      <div className="d-flex flex-row align-items-center gap-3">
                        <Rating
                          initialRating={
                            agentFeedbackData?.twoDaysAgoAverageRating
                          }
                          className="fs-3"
                          fullSymbol={
                            <FontAwesomeIcon
                              icon="star"
                              className="text-warning"
                            />
                          }
                          emptySymbol={
                            <FontAwesomeIcon icon="star" className="text-300" />
                          }
                          readonly
                        />
                        <div className="fs-1">
                          {agentFeedbackData?.twoDaysAgoCustomerCount}
                        </div>
                      </div>
                    </div>
                    <div>
                      {agentFeedbackData?.yesterdayAverageRating >=
                      agentFeedbackData?.twoDaysAgoAverageRating ? (
                        <RiseOutlined
                          style={{ fontSize: "24px", color: "#1890ff" }}
                        />
                      ) : (
                        <FallOutlined
                          style={{ fontSize: "24px" }}
                          className="text-danger"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {slideCount ? (
              <Button onClick={handleClose}>Close</Button>
            ) : (
              <Button onClick={() => setSlideCount(1)}>Next</Button>
            )}
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

export default AgentDetailModal;
